module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-item-image"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "alt": _vm.altText,
      "title": _vm.altText
    },
    on: {
      "click": _vm.showInModal
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75a4f34a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/MediaItems/MediaItemImage.vue
// module id = 891
// module chunks = 2